import React from "react";

import "./news_card.scss";
import { observer } from "mobx-react-lite";

import cover from "../../../../assets/images/cup_news_cover.png";
import { cupNewsCardType } from "../../../../schemas/cup_news";

function NewsCard(props: { card: cupNewsCardType }) {
	return (
		<div className="news_card">
			<div className="cover">
				<img src={props.card.mini_pic} alt=""></img>
			</div>
			<div className="name">{props.card.name}</div>
		</div>
	);
}

export default observer(NewsCard);
